namespace RedBullMOBILE360.SpecialEvent {
    @Serenity.Decorators.registerClass()
    export class SpecialEventImportDialog extends Serenity.PropertyDialog<any, any>  {
        private form: SpecialEventImportForm;
        public IsDataImported: boolean = false;

        constructor() {
            super();

            this.form = new SpecialEventImportForm(this.idPrefix);
        }

        protected getDialogTitle(): string {
            return "Upload Event Image";
        }

        protected getDialogButtons() {
            let buttons = [];
            buttons.push({
                text: 'Send',
                cssClass: 'export-xlsx-button',
                click: () => {
                    if (!this.validateBeforeSave())
                        return;

                    SpecialEventService.ExcelImport({
                        
                    }, (response) => {
                        let messageParts = new Array<string>();
                        if (response.Inserted > 0) messageParts.push("Image uploaded successfully");
                        if (response.Updated > 0) messageParts.push("<span style='color: red;'>Failed to upload") + "</span>";
                        response.ErrorList.forEach((val) => {
                            messageParts.push(val);
                        });

                        let message: string = messageParts.join(", ");

                        if (response.Inserted > 0) {
                            Q.success(message, () => {
                            }, {
                                htmlEncode: false
                            });
                        }
                        else if (response.Updated > 0) {
                            Q.warning(message,
                                {
                                    htmlEncode: false
                                });
                        } else {
                            Q.information(message, () => {
                            }, {
                                htmlEncode: false
                            });
                        }

                        this.IsDataImported = true;

                        this.dialogClose();
                    });
                },
            });
            buttons.push(
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            );
            return buttons;
        }


    }
}